import { render, staticRenderFns } from "./organizationArchive.vue?vue&type=template&id=09bcff96&"
import script from "./organizationArchive.vue?vue&type=script&lang=js&"
export * from "./organizationArchive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports